import { css } from "styled-components";

import interVariableFont from "./inter/Inter.ttf";
import interItalicVariableFont from "./inter/Inter-Italic.ttf";

export const Inter = css`
    @font-face {
        font-family: "Inter";
        font-style: normal;
        font-weight: 100 900;
        font-display: swap;
        src: local("Inter Variable"), local("Inter-Variable"),
            url(${interVariableFont}) format("truetype-variations");
    }

    @font-face {
        font-family: "Inter";
        font-style: italic;
        font-weight: 100 900;
        font-display: swap;
        src: local("Inter Variable Italic"), local("Inter-VariableItalic"),
            url(${interItalicVariableFont}) format("truetype-variations");
    }
`;
